import React from 'react';
import { differenceInSeconds } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useInterval } from '../../utils/interval';
import generalStyles from './styles/EvCharging.module.scss';
import styles from './styles/Battery.module.scss';

type BatteryType = {
  startTime: string;
  serverTime: string;
};

const Battery: React.FunctionComponent<BatteryType> = (props: BatteryType) => {
  const { t } = useTranslation();
  const { startTime, serverTime } = props;

  const [batteryLevel, setBatteryLevel] = React.useState<number>(0);
  const [chargeTime, setChargeTime] = React.useState<number>(differenceInSeconds(new Date(serverTime), new Date(startTime)));

  React.useEffect(() => {
    setBatteryLevel(0);
    setChargeTime(differenceInSeconds(new Date(serverTime), new Date(startTime)));
  }, [startTime, serverTime]);

  useInterval(() => {
    if (batteryLevel < 3) {
      setBatteryLevel(batteryLevel + 1);
    } else {
      setBatteryLevel(0);
    }
    setChargeTime(chargeTime + 1);
  }, 1000);

  return (
    <>
      <div className={styles.battery}>
        <span className={`${styles.segment} ${batteryLevel > 0 ? styles.activeSegment : undefined}`} />
        <span className={`${styles.segment} ${batteryLevel > 1 ? styles.activeSegment : undefined}`} />
        <span className={`${styles.segment} ${batteryLevel > 2 ? styles.activeSegment : undefined}`} />
      </div>
      <div className={`${generalStyles.detail} ${generalStyles.priceList}`}>
        <h4>{t(`evCharging:charging.currentlyCharging`)}</h4>
        {new Date(chargeTime * 1000).toISOString().slice(11, 19)}
      </div>
    </>
  );
};

export default Battery;
